// Module
var code = "<header> <div style=\"display:flex;align-items:center\"> <h2>Exceptions</h2> <a class=\"btn clear-btn\" data-test-id=\"app-errors-clear-btn\" style=\"margin-left:auto\">Clear</a> </div> <div class=\"sub-header\"></div> </header> <ul class=\"app-exceptions\"></ul> ";
// Exports
export default code;